export enum Icons {

  ArrowRightIcon = "arrow-right-icon",
  NewPropertyIcon = "new-property-icon",
  ArrowLeftIcon = "ArrowLeftIcon",
  YesIcon = "YesIcon",
  HomeOutlineIcon = "new-home_outline",
  NewEventAvailable = "new-event_available",
  NewTraffic = "new-traffic",

    MapsHomeWork = "maps_home_work",
    NewHouseIcon = "new-house"
}
